const routes = [
  {
    path: '/subjects/categories',
    name: 'subjects-categories-list',
    component: () => import(/* webpackChunkName: "page/subjects/categories/list" */'@/views/pages/subjects/categories/List'),
    meta: {
      permissions: 'subject_categories_read'
    }
  },
  {
    path: '/subjects/categories/new',
    name: 'subjects-categories-new',
    component: () => import(/* webpackChunkName: "page/subjects/categories/new" */'@/views/pages/subjects/categories/New'),
    meta: {
      permissions: 'subject_categories_write'
    }
  },
  {
    path: '/subjects/categories/:id',
    name: 'subjects-categories-single',
    component: () => import(/* webpackChunkName: "page/subjects/categories/single" */'@/views/pages/subjects/categories/Single'),
    meta: {
      permissions: 'subject_categories_read'
    }
  },
  {
    path: '/subjects/categories/:id/edit',
    name: 'subjects-categories-edit',
    component: () => import(/* webpackChunkName: "page/subjects/categories/edit" */'@/views/pages/subjects/categories/Edit'),
    meta: {
      permissions: 'subject_categories_write'
    }
  }
]

export default routes
